// extracted by mini-css-extract-plugin
export var margin0em6em = "Faq-module--margin0em6em--33b0b";
export var margin4em4em = "Faq-module--margin4em4em--98aa0";
export var section = "Faq-module--section--ffc31";